(function () {
  function init(root) {
    var slides = Array.from(root.querySelectorAll("[data-slide-index]"));
    var captions = Array.from(root.querySelectorAll("[data-caption-index]"));
    var bullets = Array.from(root.querySelectorAll("[data-slide-to]"));
    var prev = root.querySelector("[data-slide-prev]");
    var next = root.querySelector("[data-slide-next]");
    var index = 0;
    if (slides.length < 2) return;
    function setSlide(nextIndex) {
      index = Math.max(0, Math.min(slides.length - 1, nextIndex));
      slides.forEach(function (slide, i) {
        slide.classList.toggle("is-active", i === index);
      });
      captions.forEach(function (caption, i) {
        caption.classList.toggle("is-active", i === index);
      });
      bullets.forEach(function (bullet, i) {
        bullet.classList.toggle("is-active", i === index);
        bullet.setAttribute("aria-selected", i === index ? "true" : "false");
      });
      root.style.setProperty("--mt-story-index", index);
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
    }
    bullets.forEach(function (bullet) {
      bullet.addEventListener("click", function () {
        setSlide(Number(bullet.dataset.slideTo));
      });
    });
    prev.addEventListener("click", function () {
      setSlide(index - 1);
    });
    next.addEventListener("click", function () {
      setSlide(index + 1);
    });
    setSlide(0);
  }
  document.querySelectorAll("[data-mt-media-story]").forEach(init);
})();
